import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET } from "./apiRoutes";

interface UseGetBudgetDataProps {
  communityId: string;
  budgetId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getBudgetDataById = async (
  communityId: string,
  budgetId: string
) =>
  axiosAuth.get(
    `${BUDGET(communityId)}/${budgetId}`
  );

const useGetBudgetById = ({
  queryParams,
  communityId,
  budgetId,
}: UseGetBudgetDataProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["budget-data", communityId, budgetId],

    queryFn: () =>
      getBudgetDataById(communityId, budgetId),

    select: (data: any) => data.data,

    refetchOnWindowFocus: false,

    ...queryParams,

    enabled: !!communityId && !!budgetId && (queryParams?.enabled ?? true),
  });
};

export default useGetBudgetById;
